import sanitizeHtml from "sanitize-html"

const textFormatter = () => {
  const newLineCodeToBr = (str: string) => {
    if(str === null) {
      return ""
    }
    return sanitizeHtml(str.replace(/\r?\n/g, "<br>"))
  }

  const formatNumberWithComma = (num: number | null | undefined): string => {
    if (num === null || num === undefined) {
      return ""
    }
    return num.toLocaleString()
  }

  return {
    newLineCodeToBr,
    formatNumberWithComma
  }
}
export { textFormatter }
